<template>
  <!-- Modal tapu -->
  <div
    class="modal fade"
    id="why-asking-tc-modal"
    ref="whyAskingTcModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="why-asking-tc-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="why-asking-tc-modal">Yakınımın kimlik numarası neden isteniyor?</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <iframe
            width="560"
            height="315"
            class="full-width"
            :src="vid"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">Kapat</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'HowToChooseModal',
  data() {
    return {
      vid: 'https://www.youtube.com/embed/FD471lt806o',
    };
  },
  methods: {
    setVideo() {
      this.vid = 'https://www.youtube.com/embed/FD471lt806o';
    },
    closeVideo() {
      this.vid = '';
    },
  },
  mounted() {
    $(this.$refs.whyAskingTcModal).on('hidden.bs.modal', this.closeVideo);
    $(this.$refs.whyAskingTcModal).on('shown.bs.modal', this.setVideo);
  },
};
</script>
